import { render, staticRenderFns } from "./SubtabHeaderLink.vue?vue&type=template&id=dba2cf0c&scoped=true&"
import script from "./SubtabHeaderLink.vue?vue&type=script&lang=js&"
export * from "./SubtabHeaderLink.vue?vue&type=script&lang=js&"
import style0 from "./SubtabHeaderLink.vue?vue&type=style&index=0&id=dba2cf0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba2cf0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
